<div [id]="htmlId ? htmlId : 'kazaplan-360-viewer'"></div>
